import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label']
  static values = { url: String, text: String }

  declare readonly labelTarget: HTMLElement
  declare readonly urlValue: string
  declare readonly textValue: string

  #originalLabel = ''

  connect() {
    this.#originalLabel = this.labelTarget.textContent ?? ''
  }

  async copy() {
    const content = this.textValue || this.urlValue
    await navigator.clipboard.writeText(content)
    this.labelTarget.textContent = 'Copied!'
    setTimeout(() => {
      this.labelTarget.textContent = this.#originalLabel
    }, 2000)
  }
}
